<template>
  <v-container>
    <div class="pl-6 pr-2 py-3">
      <h2
        class="d-flex justify-space-between align center mb-1"
        :class="type === 'Metrics' ? 'pb-3' : '' "
      >
        {{ drawerTitle }}
        <v-btn
          icon
          small
          class="ma-0 pa-0"
          @click.stop="$store.commit('ui/drawer.right.toggle')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </h2>
      <v-row v-if="type !== 'Metrics'">
        <v-col
          cols="12"
          class="body-2 pt-2 grey--text text--darken-2 font-weight-medium mb-3 text-left"
        >
          Select the {{ type === 'ISPs' ? 'ISPs metrics' : 'optional fields' }} you would like to include in your report.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model.trim="search"
            outlined
            label="Search"
            prepend-inner-icon="search"
            class="mr-1"
          />
        </v-col>

        <v-col
          class="my-0 py-0 text-capitalize"
          cols="12"
        >
          <v-checkbox
            v-model="selectAll"
            color="rgb(3, 182, 252)"
            label="Select All"
            @change="selectAllItems"
          />
        </v-col>
        <v-col
          cols="12"
          class="custom-divider pt-0"
        >
          <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5 mb-3">
            <span class="white"> Selected {{ type }} ({{ selectedItems.length }})</span>
          </div>
        </v-col>
        <v-col
          v-for="(item) in selectedItems"
          :key="item[0]"
          class="my-0 py-0 text-capitalize"
          cols="12"
        >
          <v-checkbox
            v-if="item[1].toLowerCase().includes(search.toLowerCase())"
            v-model="$store.state.reports[dataSelector]"
            :value="item[0]"
            color="rgb(3, 182, 252)"
            :label="item[1]"
            @change="removeItem(item[0])"
          />
        </v-col>
        <v-col
          cols="12"
          class="custom-divider"
        >
          <div class="body-2 strike-not-through grey--text text--darken-2 text-left pl-5 mb-3">
            <span class="white"> Unselected {{ type }} ({{ unselectedItems.length }})</span>
          </div>
        </v-col>
        <v-col
          v-for="(item) in unselectedItems"
          :key="item[0]"
          class="my-0 py-0 text-capitalize"
          cols="12"
        >
          <v-checkbox
            v-if="item[1].toLowerCase().includes(search.toLowerCase())"
            color="rgb(3, 182, 252)"
            :label="item[1]"
            @change="addItem(item[0])"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        dataSelector: '',
        totalItems: '',
        selectAll: false,
      }
    },
    computed: {
      drawerTitle () {
        let title
        switch (this.type) {
          case 'ISPs':
            title = 'ISPs'
            break
          case 'Fields':
            title = 'Optional Fields'
            break
          case 'Metrics':
            title = 'Performance Metrics'
            break
        }
        return title
      },
      selectedItems () {
        const items = []
        Object.entries(this.$store.state.reports[this.totalItems]).map(item => {
          if (this.$store.state.reports[this.dataSelector].includes(item[0])) items.push(item)
        })
        return items
      },
      type: {
        get () { return this.$store.state.ui.drawer.right.type },
        set (value) { this.$store.state.ui.drawer.right.type = value },
      },
      unselectedItems () {
        const items = []
        Object.entries(this.$store.state.reports[this.totalItems]).map(item => {
          if (!this.$store.state.reports[this.dataSelector].includes(item[0])) items.push(item)
        })
        return items
      },
      filteredFields: function () {
        if (this.search) {
          return Object.entries(this.$store.state.reports[this.totalItems]).map((field) => {
            if (field[1].includes(this.search)) {
              return field
            }
          })
        } else return this.$store.state.reports[this.totalItems]
      },
    },
    watch: {
      '$store.state.reports': {
        handler () {
          this.updateSelectAll()
        },
        deep: true,
        immediate: true,
      },
    },
    mounted () {
      this.updateSelectAll()
    },
    methods: {
      updateSelectAll () {
        this.dataSelector = this.type === 'ISPs' ? 'selectedISPs' : 'selectedFields'
        this.totalItems = this.type === 'ISPs' ? 'isps' : 'customFields'
        const selectedValLen = Object.keys(this.$store.state.reports[this.dataSelector]).length
        this.selectAll = Object.keys(this.$store.state.reports[this.totalItems]).length === selectedValLen && selectedValLen > 0
      },
      selectAllItems () {
        this.$store.state.reports[this.dataSelector] = []
        if (this.selectAll) {
          Object.keys(this.$store.state.reports[this.totalItems]).map(item => {
            this.$store.state.reports[this.dataSelector].push(item)
          })
        }
      },
      addItem (item) {
        this.$store.state.reports[this.dataSelector].push(item)
      },
      removeItem (item) {
        const index = this.$store.state.reports[this.dataSelector].findIndex(val => val === item)
        if (index >= 0) {
          this.$store.state.reports[this.dataSelector].splice(index, 1)
        }
      },
    },
  }
</script>

<style scoped>
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
</style>
<style lang="scss">
  .custom-divider {
    .strike-not-through {
    position: relative;
    text-align: center;
  }
  .strike-not-through :first-line {
    background-color: white;
  }
  .strike-not-through :before {
    position: absolute;
    z-index: -1;
    content: "";
    left: 0px;
    right: 0px;
    height: 1px;
    top: 50%;
    background-color: #EFE1E1;
  }
  }
</style>
